import { render } from "./nap.vue?vue&type=template&id=653795bb"
import script from "./nap.vue?vue&type=script&lang=js"
export * from "./nap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__